export enum ConcentrationUnits {
  KilogramsCubicDecimeter,
  GramsCubicCentimeter,
  MilligramsLiter,
  Ppm,
  NaClPercent,
  NaClGramsLiter,
  MilliequivalentsLiter,
}
